import { render, staticRenderFns } from "./shopxiang.vue?vue&type=template&id=1de3b5b6&scoped=true&"
import script from "./shopxiang.vue?vue&type=script&lang=js&"
export * from "./shopxiang.vue?vue&type=script&lang=js&"
import style0 from "./shopxiang.vue?vue&type=style&index=0&id=1de3b5b6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de3b5b6",
  null
  
)

export default component.exports